import _Device from "../playmore/device"

class Device extends _Device {
  constructor() {
    super()
    this.numpad = true
    this._volumeRange = 100
    this.isSTB = false
  }
  _init = async () => {
    return super._init()
  }

  properties = async () => {
    return super.properties("jedi")
  }
  baseUrl = async () => {
    return super.baseUrl()
  }
  async getKeyMap() {
    return [
      // Controllers
      [21, "left"],
      [19, "up"],
      [22, "right"],
      [20, "down"],
      [23, "enter"],
      [4, "back"],
      [3, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [126, "play"],
      [127, "pause"],
      [85, "toggle"],
      [86, "stop"],
      [90, "fw"],
      [89, "rw"],
      [-1, "prev"],
      [-1, "next"],

      // TV
      [166, "ch_up"],
      [167, "ch_down"],
      [170, "tv"], //Register
      [-1, "subtitle"], //Register
      [-1, "list"], //Register
      [-1, "epg"],

      // General
      [165, "info"],
      [722, "settings"], //Register
      [710, "alarm-clock"],
      [700, "sleep-timer"],
      [701, "sleep-timer"],
      [178, "source"], //Register
      [-1, "power"],
      [3, "home"], //Register
      [726, "home"], //Register
      [-1, "refresh"],

      [183, "red"],
      [184, "green"],
      [185, "yellow"],
      [186, "blue"],

      // Numpad
      [7, "numpad", 0],
      [8, "numpad", 1],
      [9, "numpad", 2],
      [10, "numpad", 3],
      [11, "numpad", 4],
      [12, "numpad", 5],
      [13, "numpad", 6],
      [14, "numpad", 7],
      [15, "numpad", 8],
      [16, "numpad", 9],

      // Applications
      [721, "youtube"],
      [375, "netflix"],
      [757, "prime"],
      [-1, "spotify"],
      [-1, "browser"],
      [719, "cast"],
      [-1, "movies"],
      [-1, "musics"],
      [-1, "usb"]
    ]
  }
  setName = async name => {
    if (!name) return false
    const { mac, ip } = __.device.properties

    const match = /ROOM_(\d+)_?/g.exec(name)
    if (match) playmore.device.setRoomNumber(parseInt(match[1]))

    playmore.device.setDeviceName(name)
    playmore.device.setUniqueName(mac + "-" + ip)
    return playmore.device.getDeviceName()
  }
  getName = async () => {
    return super.getName()
  }

  /* Register Methods */
  registerKeys = async (extras = []) => {
    let blackList = ["KEYCODE_VOLUME_DOWN", "KEYCODE_VOLUME_UP", "KEYCODE_VOLUME_MUTE"]
    if (Array.isArray(extras)) blackList = [...blackList, ...extras]

    playmore.device.setForwardedKeyEvents(
      JSON.parse(playmore.device.getCDBKeyEvents())
        .map(key => key.name)
        .filter(key => !blackList.includes(key))
        .join(",")
    )
  }

  /* Volume Management */
  volume = async volume => {
    return super.volume(volume)
  }
  mute = async value => {
    if (["boolean", "number"].indexOf(typeof value) >= 0) return playmore.device.mute(value)
    return playmore.device.mute()
  }
  maxVolume = async () => {
    playmore.device.maxVolume(__.device.maxVolume)
    return true
  }

  /* Power Management */
  getPowerState = async () => {
    return playmore.device.getPowerState().toLowerCase()
  }
  powerOn = async () => {
    return playmore.device.tvOn()
  }
  standBy = async () => {
    return playmore.device.tvOff()
  }
  reboot = async () => {
    return super.reboot()
  }
  clearData = async () => {
    return true()
  }

  /* Soft AP */
  async getSoftAP() {
    const ssid = this.generateSoftAPSSID()
    const password = this.generateSoftAPPassword()

    return {
      ssid: ssid,
      password: password,
      status: false
    }
  }
  async enableSoftAP() {
    return true
  }
  async disableSoftAP() {
    return true
  }
  async isSoftAPEnabled() {
    return false
  }
}

export default Device
